// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1wDJO","label":"Section_label__3R1uf","contentWrap":"Section_contentWrap__3gxI-","footer":"Section_footer__14YpN","footerInner":"Section_footerInner__QdJTK"};